import React from "react";
import "../styles/style.css";
import HeaderSerene from "../components/HeaderSerene";
import HeroWoods from "../components/cybermeadows/HeroWoods";
import WoodsLogo from "../assets/images/woods-logo.avif";
import "../styles/WoodsSite.css";
import AboutWoods1 from "../components/cybermeadows/AboutWoods1";
import ApprovedBanks from "../components/ApprovedBanks";
import WoodsSpecificationAccordion from "../components/cybermeadows/WoodsSpecificationAccordion";
import ContactWoods from "../components/cybermeadows/ContactWoods";
import Clubhouse from "../components/cybermeadows/ClubHouseWoods";
import AboutWoods from "../components/cybermeadows/AboutWoods";
import WoodsMasterplan from "../components/cybermeadows/WoodsMasterplan";
import LocationWoods from "../components/cybermeadows/LocationWoods";

const menuLinks = [
  { label: "ABOUT WOODS", target: "about-serene" },
  { label: "AMENITIES", target: "woods-clubhouse" },
  { label: "MASTERPLAN", target: "woods-masterplay" },
  { label: "LOCATION", target: "woods-location" },
  { label: "SPECIFICATIONS", target: "serene-specifications" },
  { label: "CONTACT", target: "serene-contact" },
];
function CyberMeadows() {
  return (
    <section id="home-woods">
      <HeaderSerene logo={WoodsLogo} menuLinks={menuLinks} />
      <HeroWoods />
      <AboutWoods />
      <AboutWoods1 />
      <Clubhouse />
      <WoodsMasterplan />
      <LocationWoods />
      <WoodsSpecificationAccordion />
      <ApprovedBanks />
      <ContactWoods />
    </section>
  );
}

export default CyberMeadows;
